import { IApplicationState } from '../../../types/types';
import { getFullLoadedBoards } from './getFullLoadedBoards';
import { getNumberKeys } from '../../../helper/getNumberKeys';

export const getFullLoadedBoardIds = (
    state: IApplicationState,
): number[] => {
    return getNumberKeys(getFullLoadedBoards(state));
}
